import React from 'react';

const Experiences = () => {
    return (
        <div>
            <div className="card">
                <div className="card-content">
                    <h6>
                        <strong>EXPERIENCE</strong>
                    </h6>
                    <span>
                        Currently, I am still a student 4nd year at a university
                        in Vietnam 😁😁
                    </span>
                </div>
            </div>
        </div>
    );
};

export default Experiences;
